__turbopack_context__.v({
  "main": "Image-module-scss-module__dmg-0q__main",
});
